import { render } from "./SecurityCode.vue?vue&type=template&id=9638f876&lang=pug"
import script from "./SecurityCode.vue?vue&type=script&lang=js"
export * from "./SecurityCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__